import React, { useState } from "react";
// import UserPanelSidebar from './UserPanelSidebar'
// import userpanel from "../../Assets/images/userpanel.jpg";
// import girl from "../../Assets/images/pic-large.jpg";
import { useSelector } from "react-redux";
import { selectUserData } from "../../Redux/UserSlice";
import { api_url } from "../../Constants/web_services";
import ChangePassword from "./UserPanelParts/ChangePassword";
import Swal from "sweetalert2";

const ProfileScreen = () => {
  // const dispatch = useDispatch();
  // const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);
  const [name, setName] = useState(userData?.username || "");
  const [c_code, setC_code] = useState(userData?.c_code || "");
  const [contact, setContact] = useState(userData?.contact || "");
  const [address, setAddress] = useState(userData?.address || "");
  const [email, setEmail] = useState(userData?.email || "");
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // const [password, setPassword] = useState(userData?.password || '');

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
    const imageURL = URL.createObjectURL(file);
    setPreviewImage(imageURL);
  };

  const updateProfile = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('username', name);
    formData.append('c_code', c_code);
    formData.append('contact', contact);
    formData.append('address', address);
    formData.append('email', email);
    if (selectedImage) {
      formData.append('image', selectedImage);
    }

    const token = localStorage.getItem('token');

    const response = await fetch(api_url + '/api/updateuser', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });

    if (response.ok) {
      Swal.fire({
        title: 'Profile updated successfully',
        icon: 'success',
        timer: 1500
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Profile update failed',
        icon: 'error'
      });
    }
  };


  return (
    <>
      {/* <UserPanelSidebar /> */}

      <div id="content">
        <div className="content-admin-main my-5">
          <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
            <h2>User Panel</h2>
          </div>

          <div className="aon-admin-heading">
            <h4 className="s-16 fw-700 text-022279">Edit Profile</h4>
          </div>
          <div className="card aon-card border-0 shadow">
            <div className="card-header bg-transparent aon-card-header py-4">
              <h4 className="s-16 fw-700 text-022279 text-capitalize">
                <i className="fa fa-user m-2 " />
                {userData?.username} {" "}
                Profile
              </h4>
            </div>
            <form onSubmit={updateProfile}>
              <div className="card-body aon-card-body">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="aon-staff-avtar">
                      <div className="aon-staff-avtar-header">
                        <div
                          className="aon-pro-avtar-pic"
                          style={{ height: 240, width: 220 }}
                        >
                          {previewImage ? (
                            <img src={previewImage} alt="Selected" />
                          ) : (
                            <img src={api_url + "/" + userData?.image} alt="" />
                          )}
                          <label
                            htmlFor="imageUpload"
                            className="admin-button has-toltip"
                          >
                            <i className="fa fa-camera" />
                            <span className="header-toltip">Upload Avatar</span>
                          </label>
                          <input
                            type="file"
                            name="image"
                            id="imageUpload"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                          />
                        </div>
                        <div className="aon-pro-cover-wrap">
                          <div className="aon-pro-cover-pic">
                            {previewImage ? (
                              <img src={previewImage} alt="Selected" />
                            ) : (
                              <img
                                src={api_url + "/" + userData?.image}
                                alt=""
                              />
                            )}
                          </div>
                          <div className="admin-button-upload">
                            <span>Upload Cover Image</span>
                            {/* <input type="file" name="avtar" /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Username</label>
                          <div className="aon-inputicon-box">
                            <input
                              className="form-control sf-form-control"
                              name="name"
                              type="text"
                              placeholder={userData?.username || ""}
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                            <i className="aon-input-icon fa fa-user" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Country</label>
                          <div className="aon-inputicon-box">
                            <input
                              className="form-control sf-form-control"
                              name="contact"
                              type="tel"
                              placeholder={userData?.c_code || ""}
                              value={c_code}
                              onChange={(e) => setC_code(e.target.value)}
                            />
                            <i className="aon-input-icon fa fa-building-o" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group">
                          <label>Contact</label>
                          <div className="aon-inputicon-box">
                            <input
                              className="form-control sf-form-control"
                              name="contact"
                              type="tel"
                              placeholder={userData?.contact || ""}
                              value={contact}
                              onChange={(e) => setContact(e.target.value)}
                            />
                            <i className="aon-input-icon fa fa-building-o" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Address</label>
                          <div className="aon-inputicon-box">
                            <input
                              className="form-control sf-form-control"
                              name="address"
                              type="text"
                              placeholder={userData?.address || ""}
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                            <i className="aon-input-icon fa fa-location-pin" />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 breck-w1400">
                        <div className="form-group">
                          <label>Email</label>
                          <div className="aon-inputicon-box">
                            <input
                              className="form-control sf-form-control"
                              name="email"
                              type="text"
                              placeholder={userData?.email || ""}
                              value={email}
                              disabled
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <i className="aon-input-icon fa fa-edge-legacy" />
                          </div>
                        </div>
                      </div>

                      <button type="submit" className="site-button">
                        {" "}
                        Update{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <ChangePassword />
      </div>
    </>
  );
};

export default ProfileScreen;
